var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('v-main',{staticClass:"content"},[_c('animated-background'),_vm._v(" "),_c('message'),_vm._v(" "),_c('router-view')],1),_vm._v(" "),_c('footer-menu')],1)}
var staticRenderFns = []

export { render, staticRenderFns }